import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { ProductResource } from '@df/catalog/product/product.resource';
import { GiftcardsProductPlugin } from '@df/module-giftcards/giftcards-product.plugin';
import { Giftcards } from './giftcards';
import defaultsDeep from '@df/util/fn/defaults-deep';
import { DeepPartial } from '@df/util/type/deep-partial';
declare module '@df/catalog/product/product' {
    interface Product {
        giftCard: GiftcardsProductPlugin;
    }
}

export function provideDfModuleGiftcards(options?: DeepPartial<Giftcards.IModuleOptions>): EnvironmentProviders {
    return makeEnvironmentProviders([
        provideAppInitializer(() => {
            inject(ProductResource).addPlugin(product => {
                product.giftCard = new GiftcardsProductPlugin(product);
            });
        }),
        {
            provide: Giftcards.OPTIONS,
            useValue: defaultsDeep(options || {}, Giftcards.DEFAULT_OPTIONS)
        }
    ]);
}
